<template>
    <modal dialog="modal-lg" class="dark-top" :header="true" :customClass="'heightAuto'" :footer="true">

        <div slot="title">
            <h2>Create Scheduled Task</h2>
        </div>

        <div slot="body" class="p-4">
            <schedule-task-form :scheduleTask="scheduleTask" @validationChanged="validationChanged" />
        </div>

        <div slot="footer" class="d-flex w-100 justify-content-end align-items-center">
            <button type="button" class="btn cancel wider" @click="pressCancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="pressSave" :disabled="isFormInvalid">Save</button>
        </div>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Modal from './Modal'

import scheduleTaskForm from '@/components/scheduleTasks/components/scheduleTaskForm'

export default {
    created: function () {
        this.selectAllSalesChannels()
    },
    data: function() {
        return {
            isFormInvalid: false,
            scheduleTask: {
                name: null,
                type: 1000, // 1000 - Invoice
                channelIdList: [],
                agentIdList: [],
                isToDeliverDocumentToEachEntity: false,
                cron: '0 0 1 * *', //montlhy on day 1
                emailListToSendResume: null,
                periodStart: moment().startOf("day").format('YYYY-MM-DD') + ' 00:00:00',
            }
        }
    },
    computed: {
        ...mapGetters([
            'getSalesChannelsForNewProduct'
        ]),
    },
    methods: {
        ...mapActions([
            'closeModal',
            'createScheduleTask',
            'downloadScheduledTasks'
        ]),
        selectAllSalesChannels: function () {
            this.scheduleTask.channelIdList = this.getSalesChannelsForNewProduct.map(channel => {
                return channel.channelId
            })
        },
        validationChanged: function(isInvalid) {
            this.isFormInvalid = isInvalid
        },
        pressCancel: function() {
            this.closeModal();
        },
        pressSave: function() {
            this.createScheduleTask(this.scheduleTask).then(response => {
                this.downloadScheduledTasks()
                this.closeModal()
            })
        },
    },
    components: {
        Modal,
        scheduleTaskForm
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// ScheduleTaskCreate.vue?3ed2d494